import { h, Component } from "preact";
import { Text } from "preact-i18n";
import { observer } from "mobx-preact";
import store from "../store";

@observer
class LoginModal extends Component {
  render() {
    return (
      <div>
        {store.modalState == "login" && (
          <div
            id="authorization"
            class="modal-container"
            style="display: block;"
          >
            <div class="modal-window">
              <a
                href="javascript:"
                onClick={() => store.showModal("")}
                class="modal-close"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="icon">
                  <use xlinkhref="/assets/img/icons.svg#close"></use>
                </svg>
              </a>
              <div class="modal-header">
                <div class="logo">
                  <img src="/assets/img/logo3.svg" alt="DolphNet Internet" />
                  <span>
                    <Text id="loginForm.client" />
                    <br /> <Text id="loginForm.cabinet" />
                  </span>
                </div>
              </div>
              <div class="relwrapper">
                <div
                  class={
                    "preloader-small" + (store.modalLoading ? " loading" : "")
                  }
                />
                <div class="modal-body">
                  <div>
                    <input
                      type="email"
                      onKeyUp={e => (store.loginEmail = e.target.value)}
                      value={store.loginEmail}
                      name="email"
                      placeholder={this.context.intl.dictionary.loginForm.mail}
                    />
                    <input
                      type="password"
                      onKeyUp={e => (store.loginPassword = e.target.value)}
                      value={store.loginPassword}
                      name="password"
                      placeholder={this.context.intl.dictionary.loginForm.pass}
                    />
                    <p class={"error " + (store.loginError ? "" : "hidden")}>
                      <Text id="loginForm.error" />
                    </p>
                    <button
                      disabled={!store.loginFormValid}
                      onClick={() => store.doLogin()}
                      class="blank"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon">
                        <use xlinkhref="/assets/img/icons.svg#key"></use>
                      </svg>
                      <Text id="loginForm.login" />
                    </button>
                    <a class="restore">
                      <Text id="loginForm.reset" />
                      <br /> <Text id="loginForm.resetPass" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LoginModal;



// WEBPACK FOOTER //
// ./components/loginmodal.js